import { render, staticRenderFns } from "./KeybeText.vue?vue&type=template&id=6a14ba2c&scoped=true&"
import script from "./KeybeText.vue?vue&type=script&lang=ts&"
export * from "./KeybeText.vue?vue&type=script&lang=ts&"
import style0 from "./KeybeText.vue?vue&type=style&index=0&id=6a14ba2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a14ba2c",
  null
  
)

export default component.exports